export const request_categories = () => ({
	type: 'REQUEST_CATEGORIES',
});

export const receive_categories = categories => ({
  	type: 'RECEIVE_CATEGORIES',
  	payload: categories,
});

export const set_search_value = value => ({
  	type: 'SET_SEARCH_VALUE',
  	payload: value,
});

export const fetch_categories = () => (dispatch) => {
  	dispatch(request_categories());
	return fetch(global.config.server_path+'category/get', {method: 'POST', headers: {'Content-Type':'application/json'}, 'credentials': 'include', 'body': JSON.stringify({'type': 'mockup'})})
	.then(resp => resp.json())
	.then(resp => {		
		dispatch(receive_categories(resp.data));
	})
};
